define(function (require, exports, module) {
    var ContentArticle = require('./content/ContentArticle');
    var ContentVideoList = require('./content/ContentVideoList');
    var ContentAudioList = require('./content/ContentAudioList');
    var ContentTVList = require('./content/ContentTVList');

    var AUDIO = 'audio';
    var VIDEOS = 'videos';
    var MLBTV = 'tv';
    var MiLBTV = 'tv';

    var mediaTitleMap = {
        'Audio': {
            type: AUDIO
        },
        'Extended Highlights': {
            type: VIDEOS,
            key: 'condensed'
        },
        'Daily Recap': {
            type: VIDEOS,
            key: 'recap'
        },
        'MLBTV': {
            type: MLBTV
        },
        'MiLBTV': {
            type: MiLBTV
        }
    };

    function copy (source, target) {
        target = target || {};
        var item;
        for (item in source) {
            if (source.hasOwnProperty(item)) {
                target[item] = source[item];
            }
        }
        return target;
    }

    function ContentModel (data) {
        this.articles = {};
        this.videos = {};
        this.audio = {};
        if (data) {
            this.parseData(data);
        }
    }

    ContentModel.prototype = {

        parseData: function (data) {
            this.parseArticles(data.editorial);
            this.parseMedia(data.media && data.media.epg, data.highlights);
            this.parseVideos(data.highlights);
        },

        parseArticles: function (editorial) {
            if (editorial) {
                var parsedArticles = this.articles;
                var key;
                var articleType;
                var articles;
                var article;

                for (key in editorial) {
                    articles = editorial[key];
                    if (articles) {
                        parsedArticles[key] = {};
                        for (articleType in articles) {
                            article = articles[articleType];
                            parsedArticles[key][articleType] = new ContentArticle(article[0] || article);
                        }
                    }
                }
            }
        },

        parseVideos: function (highlights) {
            if (highlights) {
                var parsedVideos = this[VIDEOS];
                var key;
                var videos;
                var allCids = this.videos.allCid = {};
                var videoList;

                for (key in highlights) {
                    videos = highlights[key];
                    if (videos && videos.items) {
                        videoList = parsedVideos[key] = new ContentVideoList(videos.items, key);
                        copy(videoList.cid, allCids);
                    }
                }
            }
        },

        parseMedia: function (media, highlights) {
            var len = media && media.length;
            if (len) {
                var mediaType;
                var mappedType;
                var i = 0;
                var type;
                var items;

                for (; i < len; i++) {
                    mediaType = media[i];
                    items = mediaType.items;
                    if (items && items.length && mediaType.title in mediaTitleMap) {
                        // Using the title is awful... asking SDBD for meaningful
                        // keys, but in the meantime:
                        mappedType = mediaTitleMap[mediaType.title];
                        type = mappedType.type;
                        if (type === AUDIO) {
                            this[type] = new ContentAudioList(items);
                        } else if (type === VIDEOS) {
                            // Move video epg items to highights for parsing
                            // This covers condensed and recap highlights
                            highlights[mappedType.key] = mediaType;
                        } else if (type === MLBTV) {
                            this[type] = new ContentTVList(items);
                        }
                    }
                }
            }
        }
    };

    return ContentModel;
});
